import { ShippingTypeEnum } from './../../../core/enum/shippingType';
import { createReducer, on } from "@ngrx/store";
import * as fromCart from './cart-state';
import { BASKET, State } from "./cart-state";
import { MarketProduct } from "../../_models/product.interface";
import * as cartActions from './cart-action';
import { ICartItemResponse, IItemCart } from "../../shopping-cart/_models/cart.interface";
import { ViewTypeEnum } from '@app/marketplace/core/enum/viewTypeEnum';

const initialState: fromCart.State = {
  data:{
    minCount: 0,
    maxCount: 50,
    maxPrice: 5000,
    minPrice: 0,
    totalItems: 0,
    totalPrice: 0,
    totalPriceToShow: "",
    signature: null,
    items:[],
  },
  isLoading:false
};
export const reducer = createReducer(
  initialState,
  on(cartActions.FetchCart, (state) => {
    return {...state,isLoading:true}
  }),
  on(cartActions.FetchCartSuccess, (state,{data}) => {
    return listCartItems(data);
  }),
  on(cartActions.FetchCartFailure, (state) => {
    return {...state,isLoading:false}
  }),
  on(cartActions.CancelCartRequest, (state) => {
    return {...state,isLoading:false}
  }),
  on(cartActions.UpdateCart, (state,) => {
    return {...state,isLoading:true}
  }),
  on(cartActions.UpdateCartSuccess, (state,{data}) => {
    return {...state, data: {...state.data, signature: data?.data?.signature}, message: data?.message, notification: data?.notification, isLoading: false, success: data?.success };
  }),
  on(cartActions.CloseErrorMessage, (state) => {
    state.success = true;
    return state;
  }),
  on(cartActions.PushToCart, (state) => {
    return {...state,isLoading:true}
  }),
  on(cartActions.PushToCartSuccess, (state,{product,viewType,quantity}) => {
    var shopcart=pushToCart(state,product,viewType,quantity);
    state.isLoading=false;
    return shopcart;
  }),
  on(cartActions.PullFromCart, (state) => {
    return {...state,isLoading:true}
  }),
  on(cartActions.PullFromCartSuccess, (state,{product}) => {
    return pullFromCart(state,product);
  }),
  on(cartActions.DeleteFromCart, (state) => {
    return {...state,isLoading:true}
  }),
  on(cartActions.DeleteFromCartSuccess, (state,{product}) => {
    return deleteFromCart(state,product);
  }),
  on(cartActions.ClearCart, (state) => {
    localStorage.setItem(BASKET.Key, JSON.stringify(initialState));
     return initialState;
  }),
  on(cartActions.CloseErrorMessage, (state) => {
    return {...state,message:"",notification:null}
  }),
  on(cartActions.SetShippingType, (state,{product,shipping}) => {
    return setShippingType(state,product,shipping);
  }),
  on(cartActions.SetShippingSuccess, (state) => {
    return {...state,isLoading:false}
  }),
  on(cartActions.SetShippingFailure, (state) => {
    return {...state,isLoading:false}
  }),
);

function setBasket(data:any) {localStorage.setItem(BASKET.Key,JSON.stringify(data));}

function listCartItems(response: ICartItemResponse):State {
  var shopcart:fromCart.State = {
     data:{
      signature: response?.data?.signature,
      items: response?.data?.items,
      minCount:  response?.data?.minCount,
      maxCount:  response?.data?.maxCount,
      maxPrice:  response?.data?.maxPrice,
      minPrice:  response?.data?.minPrice,
      totalItems: response?.data?.totalItems,
      totalPrice:  response?.data?.totalPrice,
      totalPriceToShow:  response?.data?.totalPriceToShow,
     },
     success: response?.success,
     message:response?.message,
     notification:response?.notification,
     isLoading:false
  };
  setBasket(shopcart);
  return shopcart;
}

function pushToCart(shopcart: State, product: MarketProduct,viewType:ViewTypeEnum,qty:number=1):State {
  if(!shopcart?.data?.items) return shopcart;
  shopcart.isLoading=false;

  var attributes=product.attributes? Object.entries(product.attributes):[];
  var id=attributes.length>0?attributes.map(([k, v]) => `${product.code}${k}${v}`).join(''):product.code;
  //let targetItem: IItemCart = shopcart.data.items.find(x => x.code === product.code);
  let targetItem: IItemCart = shopcart.data.items.find(x => x.id === id);
  if (targetItem) {
    //if(viewType!=ViewTypeEnum.ProductDetails)
    targetItem.quantity += qty;
    targetItem.quantityToShow=targetItem.quantity>1?`${targetItem.quantity}${"elementos"}`:`${targetItem.quantity}${"elemento"}`;
    targetItem.amount = targetItem.quantity*(product.price-product.discount);
    targetItem.amountToShow =`${"$"}${Number(targetItem.amount.toFixed(2))}`;
  }
  else {
    var item: IItemCart = {
      id,
      code: product.code,
      name: product.name,
      shortText: product.shortText,
      priceToShow: product.priceToShow,
      oldPriceToShow:product.oldPriceToShow,
      price: product.price,
      discount: product.discount,
      supplierCode: product.supplierCode,
      supplierLinkToShow: product.supplierLinkToShow,
      specifications:product.specifications,
      previewUrl:product.pictures?.length>0?product.pictures[0].previewUrl:"",
      quantity:qty,
      quantityToShow:"1 elemento",
      amount: product.price - product.discount,
      amountToShow:product.priceToShow,
      productProvider: product.provider,
      shippingType: product.shippingType??1,
      allowedShippingTypes: product.allowedShippingTypes,
      attributesToShow:product.attributesToShow,
      attributes:product.attributes,
      tags:[]
    };
    shopcart.data.items.push(item);
  }
  shopcart.data.totalItems = shopcart.data.items.length>0?  shopcart.data.items.map(a => a.quantity).reduce((a, b) => a + b):0;
  shopcart.data.totalPrice = shopcart.data.items.length>0?  shopcart.data.items.map(a => a.amount).reduce((a, b) => a + b):0;
  shopcart.data.totalPriceToShow =`${"$"}${Number(shopcart.data.totalPrice.toFixed(2))}`;

  setShippingType(shopcart,product,product.shippingType??1);
  setBasket(shopcart);
  return shopcart;
}

function pullFromCart(shopcart: State, product: MarketProduct):State {

  var attributes=product.attributes? Object.entries(product.attributes):[];
  var id=attributes.length>0?attributes.map(([k, v]) => `${product.code}${k}${v}`).join(''):product.code;
  //let targetItem: IItemCart = shopcart?.data?.items.find(x => x.code === product.code);
  let targetItem: IItemCart = shopcart?.data?.items.find(x => x.id ===id);
  if (targetItem) {
    targetItem.quantity -= 1;
    targetItem.quantityToShow=targetItem.quantity>1?`${targetItem.quantity}${"elementos"}`:`${targetItem.quantity}${"elemento"}`;
    targetItem.amount = targetItem.quantity*(product.price-product.discount);
    targetItem.amountToShow =`${"$"}${Number(targetItem.amount.toFixed(2))}`;
    if (targetItem.quantity <= 0) {
      var index = shopcart.data.items.indexOf(targetItem);
      shopcart.data.items.splice(index, 1);
     }
  }
  shopcart.data.totalItems = shopcart.data.items.length>0?  shopcart.data.items.map(a => a.quantity).reduce((a, b) => a + b):0;
  shopcart.data.totalPrice = shopcart.data.items.length>0?  shopcart.data.items.map(a => a.amount).reduce((a, b) => a + b):0;
  shopcart.data.totalPriceToShow =`${"$"}${Number(shopcart.data.totalPrice.toFixed(2))}`;
  shopcart.isLoading=false;
  //localStorage.setItem(BASKET.Key, JSON.stringify(shopcart));
  setBasket(shopcart);
  return shopcart;
}

function deleteFromCart(shopcart: State, product: any):State {
  if(!shopcart?.data?.items) return shopcart;
  var attributes=product.attributes? Object.entries(product.attributes):[];
  var id=attributes.length>0?attributes.map(([k, v]) => `${product.code}${k}${v}`).join(''):product.code;
  //let targetItem: IItemCart= shopcart.data.items.find(x => x.code === product);
  let targetItem: IItemCart= shopcart.data.items.find(x => x.id === id);
  if (targetItem) {
      var index = shopcart.data.items.indexOf(targetItem);
      shopcart.data.items.splice(index, 1);
  }
  shopcart.data.totalItems = shopcart.data.items.length>0?  shopcart.data.items.map(a => a.quantity).reduce((a, b) => a + b):0;
  shopcart.data.totalPrice = shopcart.data.items.length>0?  shopcart.data.items.map(a => a.amount).reduce((a, b) => a + b):0;
  shopcart.data.totalPriceToShow =`${"$"}${Number(shopcart.data.totalPrice.toFixed(2))}`;
  shopcart.isLoading=false;
  //localStorage.setItem(BASKET.Key, JSON.stringify(shopcart));
  setBasket(shopcart);
  return shopcart;
}

function setShippingType(shopcart: State, product: MarketProduct, shipping: ShippingTypeEnum ):State {
  shopcart.isLoading=true;
  if(!shopcart?.data?.items) return shopcart;
  var attributes=product.attributes? Object.entries(product.attributes):[];
  var id=attributes.length>0?attributes.map(([k, v]) => `${product.code}${k}${v}`).join(''):product.code;
  //let targetItem: IItemCart = shopcart.data.items.find(x => x.code === product.code);
  let targetItem: IItemCart= shopcart.data.items.find(x => x.id === id);
  if (targetItem){
    targetItem.shippingType = shipping;
    setBasket(shopcart);
  }
  return shopcart;
}

